import { ListDepartmentsRequestSchema, ListDepartmentsResponseSchema } from './list-departments.schema';
/**
 * List Departments Endpoint Contract
 * Retrieves all departments in the organization
 */ export const listDepartmentsContract = {
    method: 'GET',
    path: '/api/v2/department',
    description: 'Retrieve all departments in the organization',
    requestSchema: ListDepartmentsRequestSchema,
    responseSchema: ListDepartmentsResponseSchema,
    statusCodes: {
        success: 200,
        errors: {
            401: 'Unauthorized - user not authenticated'
        }
    }
};

//# sourceMappingURL=list-departments.contract.js.map